import JobClosedReason from "@/models/Jobs/JobClosedReason";

export default (reason: JobClosedReason) => {
    switch (reason) {
        case JobClosedReason.CreatedByMistake:
            return "Created by mistake";
            break;
        case JobClosedReason.RequirementsChanged:
            return "Requirements changed";
            break;
        case JobClosedReason.Lost:
            return "Lost"
            break;
        case JobClosedReason.PartiallyPlaced:
            return "Partially Placed"
            break;
        case JobClosedReason.FullyPlaced:
            return "Fully Placed"
            break;
    }
    return "";
}